"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MCNProvider = void 0;
const api_1 = require("./api");
const chain_1 = require("./chain");
const network_1 = require("./network");
const wallet_1 = require("./wallet");
class MCNProvider {
    mcn;
    client;
    info;
    platformChain;
    platformApi;
    jvmChain;
    jvmApi;
    juneChain;
    juneApi;
    jevmApi = {};
    juneAssetId;
    constructor(mcn = network_1.SocotraNetwork, client = api_1.JuneoClient.parse(mcn.url)) {
        this.mcn = mcn;
        this.client = client;
        this.info = new api_1.InfoAPI(client);
        this.platformChain = this.mcn.primary.platform;
        this.platformApi = new api_1.PlatformAPI(client, this.platformChain);
        this.jvmChain = this.mcn.primary.jvm;
        this.jvmApi = new api_1.JVMAPI(client, this.jvmChain);
        this.juneChain = this.mcn.primary.june;
        this.juneApi = new api_1.JEVMAPI(client, this.juneChain);
        for (const supernet of this.mcn.supernets) {
            for (const chain of supernet.chains) {
                if (chain.vm.id === chain_1.JEVM_ID) {
                    this.jevmApi[chain.id] = new api_1.JEVMAPI(client, chain);
                }
            }
        }
        this.juneAssetId = this.platformChain.assetId;
    }
    recoverAccount(recoveryData) {
        return new wallet_1.MCNAccount(this, this.mcn.recoverWallet(recoveryData));
    }
    generateAccount(wordsCount) {
        return new wallet_1.MCNAccount(this, this.mcn.generateWallet(wordsCount));
    }
    async getStaticProvider() {
        return this;
    }
    static fromId(id) {
        switch (id) {
            case network_1.MainNetwork.id: {
                return new MCNProvider(network_1.MainNetwork);
            }
            case network_1.SocotraNetwork.id: {
                return new MCNProvider(network_1.SocotraNetwork);
            }
            case network_1.GenesisNetwork.id: {
                return new MCNProvider(network_1.GenesisNetwork);
            }
            case network_1.LocalNetwork.id: {
                return new MCNProvider(network_1.LocalNetwork);
            }
            default: {
                throw new Error(`unsupported network id: ${id}`);
            }
        }
    }
    static fromHrp(hrp) {
        switch (hrp) {
            case network_1.MainNetwork.hrp: {
                return new MCNProvider(network_1.MainNetwork);
            }
            case network_1.SocotraNetwork.hrp: {
                return new MCNProvider(network_1.SocotraNetwork);
            }
            case network_1.LocalNetwork.hrp: {
                return new MCNProvider(network_1.LocalNetwork);
            }
            default: {
                throw new Error(`unsupported network hrp: ${hrp}`);
            }
        }
    }
}
exports.MCNProvider = MCNProvider;
__exportStar(require("./api"), exports);
__exportStar(require("./asset"), exports);
__exportStar(require("./chain"), exports);
__exportStar(require("./network"), exports);
__exportStar(require("./transaction"), exports);
__exportStar(require("./utils"), exports);
__exportStar(require("./wallet"), exports);
